import Vue from "vue";
import Vuex from "vuex";
import app from "./modules/app";
import user from "./modules/user";
import tagsView from "./modules/tagsView";
import permission from "./modules/permission";
import appointment from "./modules/service/appointment";
import storeAndStaff from "./modules/service/stroreAndStaff";
import order from "./modules/service/order";
import member from "./modules/service/member";
import writeOff from "./modules/service/writeOff";
import merchant from "./modules/service/merchant";
import product from "./modules/service/product";
import screen from "./modules/service/screen";
import activity from "./modules/activity/activity";
import system from "./modules/system/system";
import decoration from "./modules/decoration/decoration";
import guider from "./modules/guider/guider";
import goodsLib from "./modules/mall/goodsLib";
import live from "./modules/live/live";
import microShop from "./modules/mall/microShop";
import shop from "./modules/mall/shop";
import activityCenter from "./modules/activityCenter/activityCenter";
import officialAccounts from "./modules/officialAccountsMenu/officialAccounts";
import memberCenter from "./modules/memberCenter/memberCenter";
import memberSystem from "./modules/memberSystem/memberSystem";
import orderCenter from "./modules/orderCenter/orderCenter";
import miniProgram from "./modules/miniProgram/miniProgram";
import okrWork from "./modules/okrWork/okrWork";
import memberMarketing from "./modules/memberMarketing/memberMarketing";
import stock from "./modules/stock/stock";
import rules from "./modules/coupon/rules";
import ad from "./modules/ad/ad";
import distributionCenter from "./modules/distributionCenter/distributionCenter";
import storedValueCardCenter from "./modules/storedValueCardCenter/storedValueCardCenter";
import evaluationManagement from "./modules/evaluationManagement/evaluationManagement";
import guiderCommission from "./modules/guiderCommission/guiderCommission";
import integrationCenter from "./modules/integrationCenter/integrationCenter";
import merchants from "./modules/guiderCommission/merchants";
import smsManagement from "./modules/smsManagement/smsManagement";
import auditList from "./modules/guiderCommission/auditList";
import crmManagement from "./modules/crmManagement/crmManagement";
import operatingPlan from "./modules/operatingPlan/operatingPlan";
import assistantManagement from "./modules/assistantManagement/assistantManagement";
import verificationManagement from "./modules/verificationManagement/verificationManagement";
import home from "./modules/home/home";
import messageCenter from "./modules/messageCenter/messageCenter";
import reportCenter from "./modules/reportCenter/reportCenter";
import portraitLabelMgt from "./modules/portraitLabelMgt/portraitLabelMgt";
import thermodynamicChart from "./modules/thermodynamicChart/thermodynamicChart";
import applicationMarket from "./modules/applicationMarket/applicationMarket";
import smartPurchase from "./modules/smartPurchase/smartPurchase";
import dataoke from "./modules/dataoke/dataoke";
import auditConfiguration from "./modules/auditConfiguration/auditConfiguration";
import fortunellaVenosa from "./modules/fortunellaVenosa/fortunellaVenosa";
import getters from "./getters";
import customerBase from "@/store/modules/customerBase/customerBase";
import goodsDepositGoodsDetails from "@/store/modules/goodsDeposit/goodsDeposit";
import serviceReservation from "./modules/serviceReservation/serviceReservation";
import onLineReport from "@/store/modules/dataReport/onLine";
import offLineReport from "@/store/modules/dataReport/offLine";
import redPackageConfig from "@/store/modules/redPackageConfig/redPackageConfig";
import scrm from "./modules/scrm/scrm";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    user,
    thermodynamicChart,
    order,
    permission,
    rules,
    stock,
    ad,
    live,
    home,
    okrWork,
    crmManagement,
    assistantManagement,
    applicationMarket,
    messageCenter,
    verificationManagement,
    smsManagement,
    guiderCommission,
    integrationCenter,
    storedValueCardCenter,
    evaluationManagement,
    memberMarketing,
    merchants,
    auditList,
    reportCenter,
    operatingPlan,
    portraitLabelMgt,
    activityCenter,
    miniProgram,
    orderCenter,
    memberCenter,
    memberSystem,
    system,
    decoration,
    tagsView,
    appointment,
    storeAndStaff,
    member,
    writeOff,
    merchant,
    product,
    screen,
    activity,
    guider,
    goodsLib,
    microShop,
    shop,
    officialAccounts,
    distributionCenter,
    smartPurchase,
    dataoke,
    auditConfiguration,
    fortunellaVenosa,
    customerBase,
    goodsDepositGoodsDetails,
    serviceReservation,
    onLineReport,
    offLineReport,
    redPackageConfig,
    scrm
  },
  getters
});

export default store;
